export class SitePolygoneDto {
    id: number;
    color = "#000000";
    name = "";
    isVisible = true;
    compressedDxf?: string; // Base64 encoded compressed DXF content
    wktString?: string; // Legacy WKT string for backward compatibility

    constructor(id: number, color?: string, name?: string, isVisible?: boolean, compressedDxf?: string, wktString?: string) {
        this.id = id;
        if (color) this.color = color;
        if (name) this.name = name;
        if (isVisible !== undefined) this.isVisible = isVisible;
        if (compressedDxf) this.compressedDxf = compressedDxf;
        if (wktString) this.wktString = wktString;
    }
}